<template>
  <wrapper>
    <loading-screen :isActive="isLoading">
      <div class="main-content-wrapper">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h4 class="me-auto">Add Unit Product</h4>
          <!-- <logs/> -->
        </div>
        <product-form @submit="handleSubmitData" />
      </div>
    </loading-screen>
  </wrapper>
</template>

<script>
import ProductForm from "./Components/Form";
import { Wrapper, LoadingScreen } from "../Layout";
import { CustomButton } from "../Button";
import { alert } from "../../utils";
import Logs from "./Components/Logs.vue";

export default {
  name: "AddProductPage",
  components: { ProductForm, Wrapper, CustomButton, Logs, LoadingScreen },
  data() {
    return {
      adminId: localStorage.getItem("admin_id"),
      isLoading: false,
    };
  },
  methods: {
    async handleSubmitData(formData) {
      const sentData = {
        ...formData,
        adminId: this.adminId,
        catalogId: 0,
        productDetail: {
          ...formData.productDetail,
        },
      };

      // Adjust data for unit specifically for ram and storage onboard/removable
      if (sentData.productType == 1 || sentData.productType == 2) {
        if (sentData.ramType === "onboard") {
          sentData.customRamOnboardCapacity = sentData.productDetail.ram;
          sentData.productDetail.ram = "";
        } else if (sentData.ramType === "removable") {
          sentData.customRamOnboardCapacity = "";
        }

        // This prevent mutable data, need to parse the data like what backend need
        sentData.productDetail.storage = sentData.productDetail.storage
          .map((item) => `${item.capacity}GB ${item.type}`)
          .join(",");

        if (sentData.storageType === "onboard") {
          sentData.customStorageOnboardCapacity =
            sentData.productDetail.storage;
          sentData.productDetail.storage = "";
        } else if (sentData.storageType === "removable") {
          sentData.customStorageOnboardCapacity = "";
        }

        delete sentData.ramType;
        delete sentData.storageType;
      } else {
        if (sentData.productDetail.storage) {
          sentData.productDetail.storage =
            sentData.productDetail.storage + "GB";
        }
      }

      // Build productDetail payload based on productTypeString
      const productTypeStr = (sentData.productTypeString || "").toLowerCase();
      if (productTypeStr === "cpu") {
        sentData.productDetail = {
          brand: sentData.productDetail.brand,
          model: sentData.productDetail.model,
          processor: sentData.productDetail.processor,
          ram: sentData.productDetail.ram,
          screen: sentData.productDetail.screen,
          storage: sentData.productDetail.storage,
          vga: sentData.productDetail.vga,
        };
      } else if (productTypeStr === "laptop") {
        sentData.productDetail = {
          brand: sentData.productDetail.brand,
          model: sentData.productDetail.model,
          screen: sentData.productDetail.screen,
          processor: sentData.productDetail.processor,
          ram: sentData.productDetail.ram,
          storage: sentData.productDetail.storage,
          vga: sentData.productDetail.vga,
        };
      } else if (productTypeStr === "monitor") {
        sentData.productDetail = {
          brand: sentData.productDetail.brand,
          model: sentData.productDetail.model,
          portVga: sentData.productDetail.portVga,
          portDvid: sentData.productDetail.portDvid,
          portHdmi: sentData.productDetail.portHdmi,
          displaySize: sentData.productDetail.displaySize,
          displayType: sentData.productDetail.displayType,
        };
      } else if (productTypeStr === "printer") {
        sentData.productDetail = {
          brand: sentData.productDetail.brand,
          model: sentData.productDetail.model,
          colorTech: sentData.productDetail.colorTech,
          feature: sentData.productDetail.feature,
        };
      } else if (productTypeStr === "smartphone") {
        sentData.productDetail = {
          brand: sentData.productDetail.brand,
          model: sentData.productDetail.model,
          screen: sentData.productDetail.screen,
          processor: sentData.productDetail.processor,
          ram: sentData.productDetail.ram,
          storage: sentData.productDetail.storage,
          mainCamera: sentData.productDetail.mainCamera,
          frontCamera: sentData.productDetail.frontCamera,
          battery: sentData.productDetail.battery,
          feature: sentData.productDetail.feature,
        };
      } else if (productTypeStr === "tablet") {
        sentData.productDetail = {
          brand: sentData.productDetail.brand,
          model: sentData.productDetail.model,
          screen: sentData.productDetail.screen,
          processor: sentData.productDetail.processor,
          ram: sentData.productDetail.ram,
          storage: sentData.productDetail.storage,
          mainCamera: sentData.productDetail.mainCamera,
          frontCamera: sentData.productDetail.frontCamera,
          battery: sentData.productDetail.battery,
          feature: sentData.productDetail.feature,
        };
      } else if (productTypeStr === "keyboard") {
        sentData.productDetail = {
          brand: sentData.productDetail.brand,
          model: sentData.productDetail.model,
          specifications: sentData.productDetail.specifications,
        };
      } else if (productTypeStr === "mouse") {
        sentData.productDetail = {
          brand: sentData.productDetail.brand,
          model: sentData.productDetail.model,
          specifications: sentData.productDetail.specifications,
        };
      } else if (productTypeStr === "vga cable") {
        sentData.productDetail = {
          brand: sentData.productDetail.brand,
          model: sentData.productDetail.model,
          specifications: sentData.productDetail.specifications,
        };
      }

      this.isLoading = true;
      try {
        const response = await this.$http.post(
          process.env.ADD_CATALOG_BUNDLING,
          sentData,
          {
            timeout: 300 * 1000,
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        this.isLoading = false;
        if (response.data.status != 200) {
          throw new Error(response.data.message);
        }

        await alert().fire({
          title: "Success",
          text: `New catalog product has been successfully saved`,
          icon: "success",
          confirmButtonText: "Okay",
        });

        this.$router.push({
          path: "/catalog/edit/" + response.data.content + "?unit=1",
        });
      } catch (error) {
        this.isLoading = false;
        await alert({ confirmButtonColor: "red" }).fire({
          title: "Error",
          text:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message,
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    },
    cekPermission() {
      const permissions = localStorage
        .getItem("roles")
        .replace(/"/g, "")
        .replace("[", "")
        .replace("]", "")
        .split(",");

      if (!permissions.includes("4.2")) {
        this.$router.push("/");
      }
    },
  },
  mounted() {
    this.cekPermission();
  },
};
</script>

<style scoped>
.main-content-wrapper {
  padding: 1rem 4rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Catalog/AddCatalogPage.vue